var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.458,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Map"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14438"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 30884",
    d: "M6 18l-6-2.551V0l6 2.551z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 30885",
    d: "M12.729 15.449l-6 2.551V2.551l6-2.551z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 30886",
    d: "M19.457 18l-6-2.551V0l6 2.551z"
  })))));
}
export default SvgMap;